<style>
.bg-primary {
  background-color: #2b4e8a !important;
}

.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center"
    >
      Master RPL
      <Button
        class="btn btn-md btn-dark px-4 text-white py-2 ml-auto"
        @click="$router.go(-1)"
      >
        Kembali
      </Button>
    </div>
    <form id="form-data" @submit.prevent="postData">
      <div id="workshop">
        <div class="card-body">
          <!-- ================ FORM DATA RPL ================ -->
          <div class="card border-0 shadow p-2">
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <center>
                    <img
                      :src="lihat_foto  ? lihat_foto : '/img/placeholder-image.png'"
                      style="height:220px"
                      class=" img img-responsive elevation-2 border"
                      @error="imgError"
                      alt="User Picture"
                    />
                    <br>                  
                    <span class="text-danger">*Format Gambar(PNG), Ukuran 500 x 850</span>

                    <div class="mt-2">
                      <div class="upload-btn-wrapper">
                        <button type="button" class="btn-upload" @click="chooseFiles()"> Unggah Flyer</button>
                        <center>
                          <input type="file"  id="fileUpload"  name="myfile" @change="uploadFlyer($event)" ref="refFlyer"  />
                        </center>
                      </div>
                    </div>
                  </center>
                </div>
                <div class="form-group col-md-12">
                  <label for="nama" class="font-weight-bold">Nama RPL</label>
                  <input
                    type="text"
                    class="form-control"                    
                    id="nama"                    
                    v-model="formData.namaRpl"
                    placeholder="Masukkan Nama RPL"
                    :class="{
                      'is-invalid': $v.formData.namaRpl.$error
                    }"
                  />
                  <span class="text-danger" v-if="formData.namaRpl.length > 100">
                    *Nama RPL tidak dapat melebihi 100 karakter
                  </span>
                </div>                
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="level" class="font-weight-bold">Level</label>
                  <multiselect
                    label="namaLevel"
                    placeholder="Pilih Nama Level"
                    @input="(value) => pilihLevel(value)"
                    v-model="modelLevelPeruntukan"
                    required
                    :options="optionMasterLevel"                    
                    :class="{
                      'has-error': $v.modelLevelPeruntukan.$error
                    }"
                  ></multiselect>                                   
                </div>
              </div>
            </div>
          </div>
          <!-- ================ END FORM DATA RPL ================ -->
          
          <!-- ================ FORM DATA WORKSHOP ================ -->
          <div class="card border-0 shadow p-2" v-if="formData.sertifikasiRplMataUjiRequest.length > 0">
            <div class="card-header font-weight-bold bg-white">Data Workshop</div>
            <div class="card-body">
              <div class="form-row" v-for="(input, k) in formData.sertifikasiRplMataUjiRequest" :key="`div-workshop-${k}`">
                  <div class="form-group col-md-11">
                    <label for="mata_uji" class="font-weight-bold">Mata Uji</label>
                    <multiselect
                      :id="`workshop-${k}`"
                      label="namaMataUji"
                      placeholder="Pilih Mata Uji"
                      v-model="input.modelMultiSelect"                      
                      @input="(value) => pilihMataUji(value, k)"
                      @remove="(value) => onRemoveMataUji(value, k)"
                      :options="optionMasterMataUji"                      
                    ></multiselect>
                    <div 
                      class="text-danger" 
                      v-if="$v.formData.sertifikasiRplMataUjiRequest.$each[k].idMasterMataUji.$error">
                      Mata Uji Harus Dipilih.
                    </div>  
                  </div>
                  <div class="col-1 d-flex align-items-center mt-2">
                    <div
                      class="btn btn-sm btn-success ml-2"
                      @click="addMataUji(k)"
                      v-show="k == formData.sertifikasiRplMataUjiRequest.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                    <div
                      class="btn btn-sm btn-danger ml-2"
                      @click="(value) => removeMataUji(value, k)"
                      v-show="k || (!k && formData.sertifikasiRplMataUjiRequest.length > 1)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>              

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Biaya Pendaftaran</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric                      
                      class="form-control"
                      v-model="formData.biaya"
                      :options="{
                        minimumValue: '0',
                      }"
                      :class="{
                        'is-invalid': $v.formData.biaya.$error
                      }"
                    ></vue-autonumeric>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for class="font-weight-bold">Biaya Mengulang</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric                      
                      v-model="formData.biayaMengulang"
                      class="form-control"
                      :options="{
                        minimumValue: '0',
                      }"
                      :class="{
                        'is-invalid': $v.formData.biayaMengulang.$error
                      }"
                    ></vue-autonumeric>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for class="font-weight-bold">Jenis Biaya Mengulang</label>
                  <select 
                    name="jenisBiayaMengulang" id="jenisBiayaMengulang" 
                    class="form-control" 
                    v-model="formData.jenisBiayaMengulang"
                    :class="{
                      'border-danger': $v.formData.jenisBiayaMengulang.$error
                    }"
                  >
                    <option value="mata_uji">Per Mata Uji</option>
                    <option value="hari">Per Hari</option>
                  </select>
                </div>
              </div>

              <label for="" class="font-weight-bold mb-3">Jadwal Workshop</label>
              <div class="form-row" v-for="(input, k) in formData.jadwalRpl" :key="`div-tanggal-${k}`">
                <div class="form-group col-md-5">
                  <label :for="`tanggal-${k}`" class="font-weight-bold">Tanggal Pelaksanaan</label>                  
                  <input
                    type="date"
                    :min="input.tanggal ? input.tanggal : today"
                    class="form-control"                    
                    :id="`tanggal-${k}`"
                    v-model="input.tanggal"
                    placeholder="Pilih Tanggal"                    
                    :class="{
                      'border-danger': $v.formData.jadwalRpl.$each[k].tanggal.$error
                    }"
                  />                  
                </div>
                <div class="form-group col-md-3">
                  <label for="" class="font-weight-bold">Waktu Dimulai</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="input.waktuDimulai"
                    :max="input.waktuBerakhir"
                    :id="`waktuDimulai-${k}`"
                    :class="{
                      'border-danger': $v.formData.jadwalRpl.$each[k].waktuDimulai.$error
                    }"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="" class="font-weight-bold">Waktu Berakhir</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="input.waktuBerakhir"
                    :min="input.waktuDimulai"
                    :id="`waktuBerakhir-${k}`"
                    :class="{
                      'border-danger': $v.formData.jadwalRpl.$each[k].waktuBerakhir.$error
                    }"
                  />
                </div>
                <div class="col-1 d-flex align-items-center mt-3">
                  <div
                    class="btn btn-sm btn-success ml-2"
                    @click="addJadwal(k)"
                    v-show="k == formData.jadwalRpl.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2"
                    @click="removeJadwal(k)"
                    v-show="k || (!k && formData.jadwalRpl.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Kapasitas Peserta</label>
                  <div class="input-group mb-3">
                    <input 
                      type="number" 
                      min="0" 
                      class="form-control" 
                      placeholder="Masukkan Kapasitas" 
                      v-model="formData.kapasitas"
                      :class="{
                        'is-invalid': $v.formData.kapasitas.$error
                      }"
                    >
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Jenis Workshop</label>                  
                    <select 
                      name="jenisWorkshop" 
                      id="jenisWorkshop" 
                      class="form-control"
                      v-model="formData.jenisWorkshop"
                      :class="{
                        'is-invalid': $v.formData.jenisWorkshop.$error
                      }"
                    >   
                      <option value="online">Online</option>
                      <option value="offline">Offline</option>
                    </select>
                </div>
              </div>

              <div class="form-row" v-if="formData.jenisWorkshop == 'online'">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Link Workshop</label>
                  <div class="input-group mb-3">
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="Masukkan link workshop" 
                      v-model="formData.linkWorkshop"
                      :class="{
                        'is-invalid': $v.formData.linkWorkshop.$error
                      }"
                    >
                  </div>
                </div>
              </div>

              <div class="form-row" v-if="formData.jenisWorkshop == 'offline'">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Lokasi Workshop</label>
                  <div class="input-group mb-3">
                    <textarea 
                      name="lokasi" 
                      class="form-control" 
                      id="lokasi" 
                      cols="30" 
                      rows="5" 
                      placeholder="Masukkan lokasi workshop"
                      v-model="formData.lokasi"
                      :class="{
                        'is-invalid': $v.formData.lokasi.$error
                      }"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ================ END FORM DATA WORKSHOP ================ -->
          
          <!-- ================ FORM DATA TEST CENTER ================ -->
          <div class="card border-0 shadow p-2" v-if="formData.sertifikasiRplMataUjiRequestTc.length > 0">
            <div class="card-header font-weight-bold bg-white">Data Test Center</div>
            <div class="card-body">
              <div class="form-row" v-for="(input, k) in formData.sertifikasiRplMataUjiRequestTc" :key="`div-mataUji-${k}`">
                  <div class="form-group col-md-6">
                    <label for="mata_uji" class="font-weight-bold">Mata Uji</label>
                    <multiselect
                      :id="`mataUji-${k}`"
                      label="namaMataUji"
                      placeholder="Pilih Mata Uji"
                      v-model="input.modelMultiSelect"                
                      @input="(value) => pilihMataUjiTc(value, k)"
                      @remove="(value) => onRemoveTestCenter(value, k)"
                      :options="optionMasterMataUji"
                    ></multiselect>
                    <div 
                      class="text-danger" 
                      v-if="$v.formData.sertifikasiRplMataUjiRequestTc.$each[k].idMasterMataUji.$error">
                      Mata Uji Harus Dipilih.
                    </div> 
                  </div>
                  <div class="form-group col-md-5">
                    <label for="biaya" class="font-weight-bold">Biaya Per Mata Uji</label>
                    <vue-autonumeric
                      class="form-control"
                      :options="{
                        minimumValue: '0'
                      }"
                      v-model="input.biayaMataUji"
                    ></vue-autonumeric>
                  </div>
                  <div class="col-1 d-flex align-items-center mt-2">
                    <div
                      class="btn btn-sm btn-success ml-2"
                      @click="addTestCenter(k)"
                      v-show="k == formData.sertifikasiRplMataUjiRequestTc.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                    <div
                      class="btn btn-sm btn-danger ml-2"
                      @click="(value) => removeTestCenter(value, k)"
                      v-show="k || (!k && formData.sertifikasiRplMataUjiRequestTc.length > 1)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                  </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Biaya Pendaftaran</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric                      
                      v-model="formData.biayaTc"
                      class="form-control"
                      :options="{
                        minimumValue: '0',
                      }"
                      :class="{
                        'is-invalid': $v.formData.biayaTc.$error
                      }"
                    ></vue-autonumeric>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!-- ================ END FORM DATA TEST CENTER ================ -->

          
          <!-- ================ FORM DOKUMEN UPLOAD ================ -->
          <div class="card border-0 shadow p-2" id="divdokumen">
            <div class="card-header bg-white text-muted h4">
              Dokumen Persyaratan
            </div>
            <div class="card-body">
              <div class="form-row" v-for="(input, k) in formData.dokumenPendukungSertifikasiRpl" :key="`div-dokumen-persyaratan-${k}`">
                <div class="form-group col-md-6">
                  <label for="kode_dok" class="font-weight-bold">Dokumen</label>
                  <multiselect
                    :id="`dokumen-persyaratan-${k}`"
                    label="namaDokumen"
                    placeholder="Pilih Dokumen"
                    v-model="input.modelMultiSelect"       
                    :value="input"             
                    @input="(value) => pilihDokumenPersyaratan(value, k)"
                    @remove="(value) => onRemoveDokumenPersyaratan(value, k)"
                    :options="optionMasterDokumen">
                  </multiselect>
                  <div 
                    class="text-danger" 
                    v-if="$v.formData.dokumenPendukungSertifikasiRpl.$each[k].idMasterDokumen.$error"
                  >
                    Dokumen Harus Dipilih.
                  </div> 
                </div>
                <div class="form-group col-md-5">
                  <label for="nama_dok" class="font-weight-bold">Status Wajib Dokumen</label>
                  <select 
                    class="form-control" 
                    style="height: 42px" 
                    v-model="input.statusRequired"
                    :class="{
                      'border-danger': $v.formData.dokumenPendukungSertifikasiRpl.$each[k].statusRequired.$error
                    }"
                  >
                    <option value="1">Wajib</option>
                    <option value="0">Tidak Wajib</option>
                  </select>                  
                </div>

                <div class="col-1 d-flex align-items-center">
                  <div
                    class="btn btn-sm btn-success ml-2 mt-2"
                    @click="addDokumenPersyaratan(k)"
                    v-show="k == formData.dokumenPendukungSertifikasiRpl.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2 mt-2"
                    @click="(value) => removeDokumenPersyaratan(value, k)"
                    v-show=" k || (!k && formData.dokumenPendukungSertifikasiRpl.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ================ End FORM DOKUMEN UPLOAD ================ -->

          <!-- ================ FORM DOKUMEN UPLOAD ================ -->
          <div class="card border-0 shadow p-2" id="divpenerbitan">
            <div class="card-header bg-white text-muted h4">
              Dokumen Persyaratan Penerbitan Sertifikat
            </div>
            <div class="card-body">
              <!-- <form> -->
              <div class="form-row" v-for="(input, k) in formData.dokumenPersyaratanSertifikat" :key="`div-dokumen-sertifikat-${k}`">
                <div class="form-group col-md-6">
                  <label for="nama_dok" class="font-weight-bold">Dokumen</label>
                  <multiselect
                    :id="`dokumen-sertifikat-${k}`"
                    label="namaDokumen"
                    placeholder="Pilih Dokumen"
                    v-model="input.modelMultiSelect"                    
                    @input="(value) => pilihDokumenPenerbitan(value, k)"
                    @remove="(value) => onRemoveDokumenSertifikat(value, k)"
                    :options="optionMasterDokumen"
                  ></multiselect>
                  <div 
                    class="text-danger" 
                    v-if="$v.formData.dokumenPersyaratanSertifikat.$each[k].idMasterDokumen.$error"
                  >
                    Dokumen Harus Dipilih.
                  </div> 
                </div>
                <div class="form-group col-md-5">
                  <label for="nama_dok" class="font-weight-bold">Status Wajib Dokumen</label>
                  <select 
                    class="form-control" 
                    style="height: 42px" 
                    v-model="input.statusRequired"
                    :class="{
                      'border-danger': $v.formData.dokumenPersyaratanSertifikat.$each[k].statusRequired.$error
                    }"
                  >
                    <option value="1">Wajib</option>
                    <option value="0">Tidak Wajib</option>
                  </select>
                </div>

                <div class="col-1 d-flex align-items-center">
                  <div
                    class="btn btn-sm btn-success ml-2 mt-2"
                    @click="addDokumenSertifikat(k)"
                    v-show="k == formData.dokumenPersyaratanSertifikat.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2 mt-2"
                    @click="(value) => removeDokumenSertifikat(value, k)"
                    v-show="k || (!k && formData.dokumenPersyaratanSertifikat.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <!-- </form> -->
            </div>
          </div>
          <!-- ================ END FORM DOKUMEN UPLOAD ================ -->

          <!-- ================ STATUS ================ -->
          <div class="">
            <div class="card-body pl-0">
              <div class="row">
                <CCol sm="6">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="status"
                        id="aktif"                        
                        v-model="formData.status"
                        :value="'1'"
                      />
                      <label class="custom-control-label" for="aktif">Aktif</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="status"
                        id="tidak_aktif"                      
                        v-model="formData.status"
                        :value="'0'"
                      />
                      <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                    </div>
                  </div>
                </CCol>
              </div>
            </div>
          </div>
          <!-- ================ END STATUS ================ -->
        </div>
        <div class="card-footer bg-white border-0 ml-auto mb-5 mr-3 pt-0">
          <Button
            class="btn btn-md btn-success float-right px-4"
            type="submit"
            color="success"
          >
            Simpan
          </Button>
        </div>
      </div>
      <!-- ================ END DATA RPL ================ -->
    </form>
  </div>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment';
import MasterRplService from "@/services/rpl/master-rpl.service";
import AutoNumeric from "../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";

import { MasterDokumen } from "@/mixins/master/MasterDokumen";
import { Level } from "@/mixins/master/Level";
import { AlertUtils } from "@/mixins/AlertUtils";
import { MataUji } from "@/mixins/master/MataUji";
import { UploadImage } from "@/mixins/UploadImage";
import TextField from "@/components/formcomponent/TextField";

import BaseUrl from "@/services/base-url";
const greaterThanZero = (value) => value > 0;

const isAfterDate = (value, vm) => {
  var start = vm.waktuDimulai.split(":");
  var end = value.split(":");
  var startDate = new Date(0, 0, 0, start[0], start[1], 0);
  var endDate = new Date(0, 0, 0, end[0], end[1], 0);        

  return new Date(endDate).getTime() >= new Date(startDate).getTime();
};

export default {
  name: "master-rpl-edit",
  mixins: [
    MasterDokumen, 
    Level, 
    AlertUtils, 
    MataUji,
    UploadImage
  ],
  data() {
    return {
      baseUrl : '',
      today: '',
      selected: 0,
      jenisBiayaSelected: 'paket',
      jenisWorkshopSelected: 'online',      
      currentPage: 0,
      instruktur: [],
      mataUji: [],
      levelPeruntukan: [],
      modelLevelPeruntukan: {},
      option_grader: [],
      requiredMataUjiWorkshop: false,
      requiredMataUjiTc: false,
      selectedValue : {
        idDokumenPendukungSertifikasiRpl:"",
        contoh_dokumen :"",
        kode_dokumen:"",
        nama_dokumen:"",
        statusRequired:"",
        fileName:"",
        invalid_dokumen:false,
        idMasterDokumenPendukung:"80ca7aae-08a9-4429-a361-5c53c7ef3bab",
        modelMultiSelect:{
          idMasterDokumen:"80ca7aae-08a9-4429-a361-5c53c7ef3bab",
          namaDokumen:"Lulusan S1/ D4/ S2/ S3 Akuntansi",
          contohDokumen:null,
          kodeDokumen:"undefined",statusDelete:"0",
          statusRequired:"1",
          created_a:"2020-10-02",
          updated_at:"2020-11-20",
          created_by:"35df763c-9cae-4c7b-b806-06bb3e8ad395",
          updated_by:"b0590bc3-d4fb-4430-ac06-819ba44a802f"
        }
      },
      lihat_foto : "",
      formData: {   
        flyer : "",     
        namaRpl: "",
        idLevel: "",
        sertifikasiRplMataUjiRequest: [
          {
            idMasterMataUji: "",            
          },
        ],
        biaya: 0,
        biayaMengulang: 0,  
        jenisBiayaMengulang: "",
        jadwalRpl: [
          {
            tanggal: "",
            waktuDimulai: "",
            waktuBerakhir: "",
          },
        ],        
        kapasitas: 0,
        jenisWorkshop: "online",
        linkWorkshop: '',
        lokasi: "",
        sertifikasiRplMataUjiRequestTc: [
          {
            idMasterMataUji: "",       
            biayaMataUji: 0,
          }    
        ], 
        biayaTc : 0,              
        biayaPerMataUji: 0, 
        dokumenPendukungSertifikasiRpl: [
          {          
            idMasterDokumen: "",                        
            statusRequired : "",            
          },
        ],
        dokumenPersyaratanSertifikat: [
          {            
            idMasterDokumen: "",
            statusRequired : "",
          },
        ],                                       
        status: "",   
        deleteDokumenPendukung: [],
        deleteDokumenPenerbitan: [],
        deleteJadwal: [],
        deleteMataUji: []     
      },
    };
  },

  validations: {
    modelLevelPeruntukan: { required },
    formData: {        
      namaRpl: { required },      
      sertifikasiRplMataUjiRequest: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
        $each: {
          idMasterMataUji: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop;
            })
          }
        }
      },      
      biaya: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),        
      },
      biayaMengulang: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),        
      },  
      jenisBiayaMengulang: { 
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
      },
      jadwalRpl: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
        $each: {
          tanggal: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop
            }),
          },
          waktuDimulai: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop
            }),
          },
          waktuBerakhir: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop
            }),
            isAfterDate
          }
        }
      },      
      kapasitas: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),        
      },
      jenisWorkshop: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
      },
      linkWorkshop: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop && this.formData.jenisWorkshop === 'online'
        })
      },
      lokasi: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop && this.formData.jenisWorkshop === 'offline'
        })
      },
      sertifikasiRplMataUjiRequestTc: {
        required: requiredIf(function() {
          return this.requiredMataUjiTc;
        }),
        $each: {
          idMasterMataUji: {
            required: requiredIf(function() {
              return this.requiredMataUjiTc;
            })
          }
        }
      },      
      biayaTc : {
        required: requiredIf(function() {
          return this.requiredMataUjiTc
        }),                
      },              
      
      dokumenPendukungSertifikasiRpl: {
        required,
        $each: {
          idMasterDokumen: { required },
          statusRequired: { required }
        }
      },      
      dokumenPersyaratanSertifikat: {
        required,
        $each: {
          idMasterDokumen: { required },
          statusRequired: { required }
        }
      },                
      status: {
        required
      },        
    },
  },

  components: {
    VueAutonumeric,
    TextField,
  },

  mounted() {   
    this.baseUrl = BaseUrl(); 
    this.today = moment().format("YYYY-MM-DD");
    this.getAllLevel();
    this.getAllMataUji();
    this.getAllDokumen();
    this.getData();
  },

  methods: {

    imgError(e) {
      e.target.src = '/img/placeholder-image.png'
    },

    chooseFiles: function() {
      document.getElementById('fileUpload').click();
    },
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;

      MasterRplService.getDetailDataSertifikasiRpl(this.$route.params.id_sertifikasi_rpl)
        .then(response => {          
          this.formData = response.data.singleData;
          setTimeout(() => {
            this.modelLevelPeruntukan = this.optionMasterLevel.find(el => el.idLevelAnggota === vm.formData.level.idLevelAnggota)
          })
          var flyer = "notfound.png";
          if(response.data.singleData.flyer != null) {
            flyer = response.data.singleData.flyer;
          }
          let routeData = this.baseUrl  + "/files?filename=" + flyer + "&path=sertifikasi@rpl@flyer";
          this.lihat_foto = routeData
          
          this.formData.deleteDokumenPendukung = []
          this.formData.deleteDokumenPenerbitan = []
          this.formData.deleteJadwal = []
          this.formData.deleteMataUji = []     
          this.formData.idLevel = this.formData.level.idLevelAnggota;
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error)
          loader.hide();
        })
    },

    addJadwal(index) {
      this.formData.jadwalRpl.push({
        idJadwalRpl: "",
        tanggal: "",
        waktuDimulai: "",
        waktuBerakhir: "",
      });      
    },

    removeJadwal(index) {
      const jadwal = this.formData.jadwalRpl[index];        
      const id = jadwal.idJadwalRpl
      if(id != null) {
        this.formData.deleteJadwal.push({
          idJadwalRpl : id
        })
      }
      

      this.formData.jadwalRpl.splice(index, 1);
      
    },    

    pilihLevel(event) {
      var vm = this;
      if (event.idLevelAnggota != null) {      
        this.formData.idLevel = event.idLevelAnggota;      
      } else {
        this.formData.idLevel = "";
      }
    },
    
    // MATA UJI WORKSHOP
    addMataUji(index) {      
      this.formData.sertifikasiRplMataUjiRequest.push({
        mata_uji: "",
        idMasterMataUji: "",
        biaya : "",
        biayaMengulang : "",
        jenisBiayaMengulang : "",
        namaMataUji : "",
        modelMultiSelect: [],
        invalid_mata_uji: false,
      });
    },    

    pilihMataUji(event, k) {      
      // if(
      //   this.formData.sertifikasiRplMataUjiRequest[k].idSertifikasiRplMataUji === undefined        
      //   || this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji !== event.idMasterMataUji
      // ) {
      //   this.requiredMataUjiTc = false
      //   var data = event.idMasterMataUji
      //   var status = 0

      //   for (let index = 0; index < this.formData.sertifikasiRplMataUjiRequest.length; index++) {
      //     var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji;
      //     var idSelectMataUji = data;
      //     if (this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji == event.idMasterMataUji) {
      //       this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
      //       status = 1
      //       // this.formData.sertifikasiRplMataUjiRequest[k].modelMultiSelect = []    
      //       this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = ""   
      //       return false;
      //     } else {
      //       // this.formData.sertifikasiRplMataUjiRequest[k].modelMultiSelect = []  
      //       // const element = this.optionMasterMataUji.find(
      //       //   el => el.idMasterMataUji === this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji
      //       // );            
      //       // this.optionMasterMataUji.find(el => // comment console console.log(el.idMasterMataUji))
      //       // // comment console console.log(this.formData.sertifikasiRplMataUjiRequest[k])
      //       this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = event.idMasterMataUji;
      //       this.formData.sertifikasiRplMataUjiRequest[k].modelMultiSelect = event                                    
      //     }
      //   }

      //   if(status == 0) {          
      //     this.formData.sertifikasiRplMataUjiRequest[k].modelMultiSelect = event;
      //     this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = data;
      //   }
      // } 
      this.requiredMataUjiTc = false
      var data = event.idMasterMataUji
      var status = 0

      for (
        let index = 0;
        index < this.formData.sertifikasiRplMataUjiRequest.length;
        index++
      ) {
        var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji;
        var idSelectMataUji = data;

        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
          status = 1
          this.formData.sertifikasiRplMataUjiRequest[k].modelMultiSelect = []       
          return false;
        } 
      }
      if(status == 0) {
        this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = data;
      } 
    },

    onRemoveMataUji(value, index) {
      if(this.formData.sertifikasiRplMataUjiRequest[k].idSertifikasiRplMataUji === undefined) {
        let status = 0;

        if(status == 1) {
          this.formData.sertifikasiRplMataUjiRequest[index] = value;
        } else {
          this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji = ""
          status = 1;
        }    
      } else {
        this.removeMataUji(value, index);
      }            
    },

    removeMataUji(value, index) {
      const mataUji = this.formData.sertifikasiRplMataUjiRequest[index];      
      const id = mataUji.idSertifikasiRplMataUji; 
      if(id != null) {
          MasterRplService.deleteSertifikasiRplMataUji(id)
          .then(response => {                
            this.formData.sertifikasiRplMataUjiRequest.splice(index, 1);
            this.alertSuccess(response.data.message)
          })
          .catch(error => {
                this.alertError(error.response.data.message)
          });
      }
      
      // this.$swal
      //   .fire({
      //     title: "Peringatan!",
      //     text: "Apakah anda yakin ingin menghapus Mata Uji ini?",
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonText: "Ya",
      //     cancelButtonText: "Tidak",
      //     confirmButtonColor: "#d33",
      //     cancelButtonColor: "#3085d6",
      //     reverseButtons: true
      //   })
      //   .then(result => {
      //     if (result.value) {    
      //       this.formData.deleteMataUji.push({
      //         "idMataUjiRpl": id
      //       });                                
      
          // } else {
          //   this.formData.sertifikasiRplMataUjiRequest[index].modelMultiSelect = value;
          //   this.$swal.fire(
          //     "Cancelled",
          //     "Your imaginary file is safe :)",
          //     "error"
          //   );
          // }
        // });    
    },    

    // MATA UJI TEST CENTER
    addTestCenter(index) {
      this.formData.sertifikasiRplMataUjiRequestTc.push({        
        mata_uji: "",
        idMasterMataUji: "",
        biaya : "",
        biayaMengulang : "",
        jenisBiayaMengulang : "",
        biayaMataUji : 0,
        namaMataUji : "",
        modelMultiSelect: [],
        invalid_mata_uji: false,
      });      
    },

    pilihMataUjiTc(event, k) {                      
      if(
        this.formData.sertifikasiRplMataUjiRequestTc[k].idSertifikasiRplMataUji === undefined
        || this.formData.sertifikasiRplMataUjiRequestTc[k].idMasterMataUji !== event.idMasterMataUji
      ) {
        this.requiredMataUjiWorkshop = false;

        if (event.idMasterMataUji != null) {
          this.formData.sertifikasiRplMataUjiRequestTc[k].invalid_mata_uji = false;
        }

        var data = event.idMasterMataUji;
        this.formData.sertifikasiRplMataUjiRequestTc[k].namaMataUji = event.namaMataUji
        var status = 0

        for (let index = 0; index < this.formData.sertifikasiRplMataUjiRequestTc.length; index++) {
          var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequestTc[index].idMasterMataUji;
          var idSelectMataUji = data;
          if (idMasterMataUji == idSelectMataUji) {
            this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
            status = 1
            this.formData.sertifikasiRplMataUjiRequestTc[k].modelMultiSelect = []  
            return false;
          } 
        }
        if(status == 0) {          
          this.formData.sertifikasiRplMataUjiRequestTc[k].modelMultiSelect = event;
          this.formData.sertifikasiRplMataUjiRequestTc[k].idMasterMataUji = data;
          this.formData.sertifikasiRplMataUjiRequestTc[k].batasNilai = event.nilaiMinimum;
        }
      }       
    },    

    onRemoveTestCenter(value, index) {
      if(this.formData.sertifikasiRplMataUjiRequestTc[index].idSertifikasiRplMataUji === undefined) {
        let status = 0;

        if(status == 1) {
          this.formData.sertifikasiRplMataUjiRequestTc[index] = value;
        } else {
          this.formData.sertifikasiRplMataUjiRequestTc[index].idMasterMataUji = "";
          this.formData.sertifikasiRplMataUjiRequestTc[index].namaMataUji = "";
          this.formData.sertifikasiRplMataUjiRequestTc[index].batasNilai = "";    
          status = 1;
        }    
      } else {
        this.removeTestCenter(value, index);
      }        
    },

    removeTestCenter(value, index) {
      const mataUji = this.formData.sertifikasiRplMataUjiRequestTc[index];      
      const id = mataUji.idSertifikasiRplMataUji;            
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus Mata Uji ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {                                    
            MasterRplService.deleteSertifikasiRplMataUji(id)
              .then(response => {                
                this.formData.deleteMataUji.push({
                  "idMataUjiRpl": id
                });
                this.formData.sertifikasiRplMataUjiRequestTc.splice(index, 1);
                this.alertSuccess(response.data.message)
              })
              .catch(error => {
                this.alertError(error.response.data.message)
              });
          } else {
            this.formData.sertifikasiRplMataUjiRequestTc[index].modelMultiSelect = value;
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });                
    },

    // DOKUMEN PERSYARATAN
    addDokumenPersyaratan(index) {
      this.formData.dokumenPendukungSertifikasiRpl.push({      
        idDokumenPendukungSertifikasiRpl: "",
        contoh_dokumen: "",
        kode_dokumen: "",
        nama_dokumen: "",
        statusRequired : "",
        fileName: "",
        invalid_dokumen: false,
        idMasterDokumenPendukung: "",
      });      
    },

    pilihDokumenPersyaratan(value, k) {      
      if(
        this.formData.dokumenPendukungSertifikasiRpl[k].idDokumenPendukungSertifikasiRpl === ""
        || this.formData.dokumenPendukungSertifikasiRpl[k].idMasterDokumen !== value.idMasterDokumen
      ) {
        var data = value.idMasterDokumen;
        var status = 0

        for (let index = 0; index < this.formData.dokumenPendukungSertifikasiRpl.length; index++) {
          var idMasterDokumen = this.formData.dokumenPendukungSertifikasiRpl[index].idMasterDokumenPendukung;
          var idSelectMasterDokumen = data;

          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
            status = 1
            this.formData.dokumenPendukungSertifikasiRpl[k].modelMultiSelect = []
            break;
          } 
        }

        if(status == 0) {
          const element = this.optionMasterDokumen.find(
            el => el.idMasterDokumen === data
          );     
          this.formData.dokumenPendukungSertifikasiRpl[k].idMasterDokumenPendukung = data;   
          this.formData.dokumenPendukungSertifikasiRpl[k].modelMultiSelect = element   
        } 
      }            
    },    

    onRemoveDokumenPersyaratan(value, index) {
      this.formData.dokumenPendukungSertifikasiRpl[index].idMasterDokumenPendukung = ""
    },

    removeDokumenPersyaratan(value, index) {
      const dokumen = this.formData.dokumenPendukungSertifikasiRpl[index];        
      const id = dokumen.idDokumenPendukungSertifikasiRpl
      if(id != null) {
        this.formData.deleteDokumenPendukung.push({
            idDokumenPendukung: id
        });  
      }
      // this.$swal
      //   .fire({
      //     title: "Peringatan!",
      //     text: "Apakah anda yakin ingin menghapus dokumen ini?",
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonText: "Ya",
      //     cancelButtonText: "Tidak",
      //     confirmButtonColor: "#d33",
      //     cancelButtonColor: "#3085d6",
      //     reverseButtons: true
      //   })
      //   .then(result => {
      //     if (result.value) {    
      //       this.formData.deleteDokumenPendukung.push({
      //         "idDokumenPendukung": id
      //       });                                           
      //       MasterRplService.deleteDokumenSertifikasiRpl(id)
      //         .then(response => {                                   
                this.formData.dokumenPendukungSertifikasiRpl.splice(index, 1);
        //         this.alertSuccess(response.data.message)
        //       })
        //       .catch(error => {
        //         this.alertError(error.response.data.message)
        //       });
        //   } else {
        //     this.formData.dokumenPendukungSertifikasiRpl[index].modelMultiSelect = value;
        //     this.$swal.fire(
        //       "Cancelled",
        //       "Your imaginary file is safe :)",
        //       "error"
        //     );
        //   }
        // });                      
    },                

    // DOKUMEN SERTIFIKAT
    addDokumenSertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.push({
        idDokumenPendukung: "",
        idMasterDokumen: "",
        idMasterDokumenPendukung: "",
        statusRequired : "",
        invalid_dokumen: false,
      });
    },

    pilihDokumenPenerbitan(value, k) { 
      if(
        this.formData.dokumenPersyaratanSertifikat[k].idDokumenPendukung === ""
        || this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen !== value.idMasterDokumen
      ) {
        var data = value.idMasterDokumen;
        var status = 0

        for (
          let index = 0;
          index < this.formData.dokumenPersyaratanSertifikat.length;
          index++
        ) {
          var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
          var idSelectMasterDokumen = data;

          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
            status = 1
            this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = []
            break;
          } 
        }

        if(status == 0) {
          const element = this.optionMasterDokumen.find(
            el => el.idMasterDokumen === data
          );  

          this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;
          this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = element   
        }
      }          
    },

    onRemoveDokumenSertifikat(value, index) {
      this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen = ""
    },

    removeDokumenSertifikat(value, index) {
      const dokumen = this.formData.dokumenPersyaratanSertifikat[index];      
      const id = dokumen.idDokumenPendukung;      
      if(id != null) {
          this.formData.deleteDokumenPenerbitan.push({
            idDokumenPendukung: id
          });  
      }
      // this.$swal
      //   .fire({
      //     title: "Peringatan!",
      //     text: "Apakah anda yakin ingin menghapus dokumen ini?",
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonText: "Ya",
      //     cancelButtonText: "Tidak",
      //     confirmButtonColor: "#d33",
      //     cancelButtonColor: "#3085d6",
      //     reverseButtons: true
      //   })
      //   .then(result => {
      //     if (result.value) {    
      //       this.formData.deleteDokumenPenerbitan.push({
      //         "idDokumenPendukung": id
      //       });                                
      //       MasterRplService.deleteDokumenPenerbitanRpl(id)
      //         .then(response => {              
      //           // comment console console.log(response)  
                this.formData.dokumenPersyaratanSertifikat.splice(index, 1);
        //         this.alertSuccess(response.data.message)
        //       })
        //       .catch(error => {                
        //         this.alertError(error.response.data.message)
        //       });
        //   } else {
        //     this.formData.dokumenPersyaratanSertifikat[index].modelMultiSelect = value;
        //     this.$swal.fire(
        //       "Cancelled",
        //       "Your imaginary file is safe :)",
        //       "error"
        //     );
        //   }
        // })
        // .catch(error => {
        //   // comment console console.log(error)
        // })                     
    },    

    // PUT ACTION
    postData() {      
      this.putData(this.formData);     
    },    

    putData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });      
      formData.flyer = this.lihat_foto

      var vm = this;      
      MasterRplService.putDataSertifikasiRpl(formData)
        .then((response) => {          
          loader.hide();
          this.alertEditSuccess();         
          this.$router.push({ path : "/rpl/master-rpl" });
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError(error.response.data.message);          
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>